(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function each(list, fn){ Array.prototype.forEach.call(list, fn); }

  function initTicker(root){
    each(root.querySelectorAll('[data-ticker]'), function(t){
      if(t.dataset.done) return; t.dataset.done = '1'; t.innerHTML += t.innerHTML;
    });
  }

  function initGallery(root){
    each(root.querySelectorAll('[data-gallery]'), function(gm){
      if(gm.dataset.done) return; gm.dataset.done = '1';
      var slides = gm.querySelectorAll('img');
      var wrap = gm.parentNode;
      var thumbs = wrap.querySelector('[data-thumbs]');
      var count = gm.querySelector('[data-gcount]');
      var cur = 0;
      function show(i){
        cur = i;
        each(slides, function(s,n){ s.classList.toggle('on', n === i); });
        if(thumbs) each(thumbs.children, function(t,n){ t.setAttribute('aria-current', String(n === i)); });
        if(count) count.textContent = (i+1) + ' / ' + slides.length;
      }
      if(thumbs && slides.length > 1){
        each(slides, function(img, i){
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-current', i === 0 ? 'true' : 'false');
          b.setAttribute('aria-label', 'Image ' + (i+1));
          var t = document.createElement('img'); t.src = img.src; t.alt = '';
          b.appendChild(t);
          b.addEventListener('click', function(){ show(i); });
          thumbs.appendChild(b);
        });
      }
      var sx = 0;
      gm.addEventListener('touchstart', function(e){ sx = e.touches[0].clientX; }, {passive:true});
      gm.addEventListener('touchend', function(e){
        var dx = e.changedTouches[0].clientX - sx;
        if(Math.abs(dx) > 45 && slides.length > 1){
          show((cur + (dx < 0 ? 1 : -1) + slides.length) % slides.length);
          if(thumbs) thumbs.children[cur].scrollIntoView({block:'nearest', inline:'center', behavior:'smooth'});
        }
      });
    });
  }

  function initQty(root){
    each(root.querySelectorAll('[data-q]'), function(b){
      if(b.dataset.done) return; b.dataset.done = '1';
      b.addEventListener('click', function(){
        var input = b.parentNode.querySelector('input');
        input.value = Math.max(1, (parseInt(input.value,10) || 1) + parseInt(b.dataset.q,10));
      });
    });
  }

  function fillOnView(el, w){
    if(reduce || !('IntersectionObserver' in window)){ el.style.width = w; return; }
    new IntersectionObserver(function(e,o){
      if(e[0].isIntersecting){ el.style.width = w; o.disconnect(); }
    }, {threshold:0.4}).observe(el);
  }

  function initStock(root){
    each(root.querySelectorAll('[data-stock]'), function(el){
      if(el.dataset.done) return; el.dataset.done = '1';
      var min = parseInt(el.dataset.stockMin, 10); if(isNaN(min)) min = 6;
      var max = parseInt(el.dataset.stockMax, 10); if(isNaN(max)) max = 23;
      if(max < min){ var tmp = min; min = max; max = tmp; }
      var count = null;
      try{
        var stored = sessionStorage.getItem('shoccwaveStockCount');
        if(stored !== null){ var n = parseInt(stored, 10); if(!isNaN(n) && n >= min && n <= max) count = n; }
      }catch(e){}
      if(count === null){
        count = min + Math.floor(Math.random() * (max - min + 1));
        try{ sessionStorage.setItem('shoccwaveStockCount', String(count)); }catch(e){}
      }
      var span = el.querySelector('[data-stock-text]');
      var tpl = el.dataset.stockTemplate || (span ? span.textContent : '');
      if(span) span.textContent = tpl.replace('%COUNT%', count);
    });
    each(root.querySelectorAll('.stockbar i'), function(el){
      if(el.dataset.done) return; el.dataset.done = '1';
      fillOnView(el, el.dataset.fill || '30%');
    });
    each(root.querySelectorAll('.bar i span'), function(el){
      if(el.dataset.done) return; el.dataset.done = '1';
      fillOnView(el, el.dataset.w || '0%');
    });
  }

  function pad(n){ return n < 10 ? '0' + n : '' + n; }

  function initCutoff(root){
    each(root.querySelectorAll('[data-cutoff]'), function(box){
      if(box.dataset.done) return; box.dataset.done = '1';
      var firstMs = (parseInt(box.dataset.cutoffFirst, 10) || 60) * 60000;
      var returnMs = (parseInt(box.dataset.cutoffReturn, 10) || 15) * 60000;
      var out = box.querySelector('[data-cutdown]');
      var EXPIRY_KEY = 'shoccwaveUrgencyExpiry';
      var VISITED_KEY = 'shoccwaveUrgencyVisited';

      var expiry = null;
      try{
        var stored = localStorage.getItem(EXPIRY_KEY);
        if(stored !== null){ var n = parseInt(stored, 10); if(!isNaN(n)) expiry = n; }
      }catch(e){}

      var now = Date.now();
      if(expiry === null || expiry <= now){
        var visited = false;
        try{ visited = localStorage.getItem(VISITED_KEY) === '1'; }catch(e){}
        expiry = now + (visited ? returnMs : firstMs);
        try{
          localStorage.setItem(EXPIRY_KEY, String(expiry));
          localStorage.setItem(VISITED_KEY, '1');
        }catch(e){}
      }

      function tick(){
        var n2 = Date.now();
        var remaining = expiry - n2;
        if(remaining <= 0){
          // ran out - start the next (returning-visitor length) window so it's never stuck at zero
          expiry = Date.now() + returnMs;
          try{ localStorage.setItem(EXPIRY_KEY, String(expiry)); }catch(e){}
          remaining = expiry - Date.now();
        }
        var d = Math.floor(remaining/1000);
        if(out) out.textContent = pad(Math.floor(d/3600)) + ':' + pad(Math.floor(d/60)%60) + ':' + pad(d%60);
      }
      tick(); setInterval(tick, 1000);
    });
  }

  function initBench(root){
    each(root.querySelectorAll('[data-stage]'), function(stage){
      if(stage.dataset.done) return; stage.dataset.done = '1';
      var section = stage.closest('section');
      var glow = stage.querySelector('[data-glow]');
      var core = stage.querySelector('[data-core]');
      var pwr = section.querySelector('[data-pwr]');
      var frq = section.querySelector('[data-frq]');
      var pwrOut = section.querySelector('[data-pwr-out]');
      var frqOut = section.querySelector('[data-frq-out]');
      var note = section.querySelector('[data-note]');
      var mode = 'music', OX = 304, OY = 166;

      function bolt(x,y,ang,len,spread,depth,out,branch){
        var steps = 5 + (Math.random()*4|0), d = 'M'+x.toFixed(1)+' '+y.toFixed(1), i, l;
        for(i=0;i<steps;i++){
          ang += (Math.random()-0.5)*spread; l = len/steps;
          x += Math.cos(ang)*l; y += Math.sin(ang)*l;
          d += 'L'+x.toFixed(1)+' '+y.toFixed(1);
          if(depth>0 && Math.random()<branch){
            bolt(x,y,ang+(Math.random()-0.5)*1.3,len*0.45,spread*1.25,depth-1,out,branch*0.7);
          }
        }
        out.push(d);
      }
      function draw(){
        var p = +pwr.value/100, f = +frq.value/100, out = [], i, n, len, spread, ang;
        if(mode === 'music'){
          n = Math.round(10+p*26+f*14); len = 70+p*120; spread = 0.22+f*0.3;
          for(i=0;i<n;i++){
            ang = -Math.PI/2 + (Math.random()-0.5)*(1.5+f*1.5);
            bolt(OX,OY,ang,len*(0.55+Math.random()*0.65),spread,1,out,0.12);
          }
        } else {
          n = Math.round(2+p*4); len = 110+p*180; spread = 0.5+f*0.35;
          for(i=0;i<n;i++){
            ang = -Math.PI/2 + (Math.random()-0.5)*1.5;
            bolt(OX,OY,ang,len*(0.7+Math.random()*0.5),spread,3,out,0.42);
          }
        }
        var path = out.join(' ');
        glow.innerHTML = '<path d="'+path+'"/>';
        core.innerHTML = '<path d="'+path+'"/>';
        glow.setAttribute('stroke-width', (2.2+p*3.4).toFixed(1));
        glow.setAttribute('opacity', (0.5+p*0.45).toFixed(2));
      }
      function readouts(){
        pwrOut.textContent = pwr.value + '%';
        frqOut.textContent = (0.8 + (+frq.value/100)*3.4).toFixed(1) + ' kHz';
      }
      var last = 0, running = true;
      function loop(t){
        if(!running) return;
        if(t - last > (mode === 'music' ? 55 : 110)){ draw(); last = t; }
        requestAnimationFrame(loop);
      }
      readouts(); draw();
      if(!reduce){
        requestAnimationFrame(loop);
        document.addEventListener('visibilitychange', function(){
          running = !document.hidden;
          if(running){ last = 0; requestAnimationFrame(loop); }
        });
      }
      pwr.addEventListener('input', function(){ readouts(); draw(); });
      frq.addEventListener('input', function(){ readouts(); draw(); });
      each(section.querySelectorAll('.modes button'), function(b){
        b.addEventListener('click', function(){
          mode = b.dataset.mode;
          each(section.querySelectorAll('.modes button'), function(x){
            x.setAttribute('aria-pressed', String(x === b));
          });
          if(note) note.textContent = mode === 'music' ? note.dataset.noteA : note.dataset.noteB;
          draw();
        });
      });
    });
  }

  function initBundles(root){
    each(root.querySelectorAll('.bundles'), function(group){
      if(group.dataset.done) return; group.dataset.done = '1';
      var form = group.closest('form');
      each(group.querySelectorAll('input[type=radio]'), function(r){
        r.addEventListener('change', function(){
          each(group.querySelectorAll('.bundle'), function(l){
            l.setAttribute('data-on', String(l.contains(r) && r.checked));
          });
          if(!form) return;
          var qty = form.querySelector('input[name=quantity]');
          if(qty && r.dataset.qty) qty.value = r.dataset.qty;
          var id = form.querySelector('[name=id]');
          if(id && r.dataset.variant) id.value = r.dataset.variant;
        });
      });
    });
  }

  /* ---------- sticky cart icon ---------- */
  function updateCartBadge(count, bump){
    var badge = document.querySelector('[data-cart-badge]');
    if(!badge) return;
    badge.textContent = count > 99 ? '99+' : String(count);
    badge.classList.toggle('show', count > 0);
    if(bump){
      var fab = document.querySelector('[data-cart-fab]');
      if(fab && !reduce){
        fab.classList.remove('bump');
        void fab.offsetWidth;
        fab.classList.add('bump');
      }
    }
  }

  function refreshCartBadge(bump){
    return fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(cart){ updateCartBadge(cart.item_count, bump); })
      .catch(function(){});
  }

  function initAddToCart(root){
    each(root.querySelectorAll('#buy-form'), function(form){
      if(form.dataset.ajaxBound) return; form.dataset.ajaxBound = '1';
      form.addEventListener('submit', function(e){
        var submitter = e.submitter;
        var name = submitter && submitter.name;
        if(name === 'checkout') return; // let this go straight to checkout as normal

        e.preventDefault();
        var fd = new FormData(form);
        if(submitter && submitter.name) fd.set(submitter.name, submitter.value || '');
        if(submitter) submitter.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Accept': 'application/json'},
          body: fd
        })
          .then(function(r){ return r.json().then(function(data){ return {ok: r.ok, data: data}; }); })
          .then(function(res){
            if(submitter) submitter.disabled = false;
            if(!res.ok){
              alert((res.data && res.data.description) || 'Sorry, that could not be added to your cart.');
              return;
            }
            return refreshCartBadge(true);
          })
          .catch(function(){
            if(submitter) submitter.disabled = false;
            form.submit();
          });
      });
    });
  }

  function initCartFab(){
    if(!document.querySelector('[data-cart-fab]')) return;
    refreshCartBadge(false);
  }

  function openDrawer(drawer, btn){
    drawer.classList.add('open');
    if(btn) btn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    var closeBtn = drawer.querySelector('[data-nav-close]');
    if(closeBtn) closeBtn.focus();
  }
  function closeDrawer(drawer){
    drawer.classList.remove('open');
    document.body.style.overflow = '';
    var toggle = document.querySelector('[data-nav-toggle][aria-controls="' + drawer.id + '"]');
    if(toggle){ toggle.setAttribute('aria-expanded', 'false'); toggle.focus(); }
  }

  // Nav drawer: bound once at document level (not inside init()) so it
  // can never be skipped by an error thrown in an unrelated init function.
  document.addEventListener('click', function(e){
    var toggle = e.target.closest('[data-nav-toggle]');
    if(toggle){
      var drawer = document.getElementById(toggle.getAttribute('aria-controls'));
      if(drawer) openDrawer(drawer, toggle);
      return;
    }
    var closeBtn = e.target.closest('[data-nav-close]');
    if(closeBtn){
      var d = closeBtn.closest('[data-nav-drawer]');
      if(d) closeDrawer(d);
      return;
    }
    var backdrop = e.target.closest('[data-nav-backdrop]');
    if(backdrop){
      var d2 = backdrop.closest('[data-nav-drawer]');
      if(d2) closeDrawer(d2);
      return;
    }
    var navLink = e.target.closest('[data-nav-drawer] nav a');
    if(navLink){
      var d3 = navLink.closest('[data-nav-drawer]');
      if(d3) closeDrawer(d3);
    }
  });
  document.addEventListener('keydown', function(e){
    if(e.key !== 'Escape') return;
    each(document.querySelectorAll('[data-nav-drawer].open'), function(d){ closeDrawer(d); });
  });

  function init(root){
    root = root || document;
    initTicker(root); initGallery(root); initQty(root);
    initStock(root); initCutoff(root); initBench(root); initBundles(root);
    initAddToCart(root);
  }
  if(document.readyState !== 'loading'){ init(); initCartFab(); }
  else { document.addEventListener('DOMContentLoaded', function(){ init(); initCartFab(); }); }
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
